import React, { useState, useMemo, useContext, useReducer } from 'react'
import './LoginPage.scss'
import { Image, Grid, Header, Form, Segment, Button, Divider } from 'semantic-ui-react'
import logo from 'assets/images/RDP.png'
import { toast } from 'react-toastify'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { GlobalContext } from 'globalContext'
import jwt from 'jsonwebtoken'
import { useSubscription } from 'utils'
import history from 'services/history'

const initialFormValues = {
    user: '',
    password: ''
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function LoginPage() {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [loading, setLoading] = useState(false);
    const [, setGlobal] = useContext(GlobalContext)

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    const handleSubmitlogin = () => {
        if (form.user !== '' && form.password !== '') {
            setLoading(true);
        } else {
            toast.error('Preencha todos os campos para continuar.')
        }
    }

    const makeLogin$ = useMemo(() => request({
        url: '/authenticate/restaurante',
        method: 'POST',
        body: form
    }).pipe(
        tap(({ response }) => {
            localStorage.setItem('JWTR', response.token)
            setGlobal({
                type: 'setUserRest',
                payload: jwt.decode(response.token)
            })
            history.push('/restaurante/inicio')
        }),
        finalize(() => setLoading(false))
    ), [form, setGlobal])

    useSubscription(makeLogin$, loading)

    return (
        <div id='restaurante-login'>
            <Grid textAlign='center' style={{ height: '80vh' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Segment raised>
                        <Form size='large' loading={loading} onSubmit={handleSubmitlogin}>
                            <Segment basic>
                                <Image src={logo} size='small' centered />
                                <Divider />
                                <Header as='h2' textAlign='center' className='tituloStyle'>
                                    Restaurantes
                            </Header>
                                <Divider />
                                <Form.Input
                                    fluid
                                    icon='user'
                                    iconPosition='left'
                                    placeholder='Usuário'
                                    value={form.user}
                                    name='user'
                                    onChange={handleChange}
                                    autoFocus
                                />
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder='Senha'
                                    type='password'
                                    value={form.password}
                                    name='password'
                                    onChange={handleChange}
                                />
                                <Button loading={loading} color='blue' fluid size='large'>
                                    Acessar
                                </Button>
                            </Segment>
                        </Form>
                    </Segment>
                </Grid.Column>
            </Grid>
        </div>
    )
}